<template lang="pug">
modal#delete-developer-client-modal(
  :close-button-label='$t("modal.deleteDeveloperClient.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteDeveloperClient.processButtonLabel")'
  :title='$t("modal.deleteDeveloperClient.title")'
  @process='submit'
  processButtonClass='btn-danger'
  ref='modal'
)
  .text-center
    div(v-if='isSandbox')
      p.text-start {{ $t('modal.deleteDeveloperClient.sandboxMessage1') }}
      p.text-start {{ $t('modal.deleteDeveloperClient.sandboxMessage2') }}
      p.text-start {{ $t('modal.deleteDeveloperClient.sandboxMessage3') }}
    div(v-else)
      p.text-start {{ $t('modal.deleteDeveloperClient.productionMessage1') }}
      p.text-start {{ $t('modal.deleteDeveloperClient.productionMessage2') }}

    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/developer-delete-warning.svg'
    )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import Icon from '@/ui/atoms/Icon.vue';
import OauthService from '@/services/Oauth';

export default {
  name: 'DeleteDeveloperClientModal',
  props: {
    clientId: [Number, String],
    isSandbox: Boolean,
  },
  components: {
    Modal,
    Icon,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    modalTitle() {
      return this.title;
    },
  },
  methods: {
    submit() {
      this.loading = true;
      OauthService.deleteClient(this.clientId).then(() => {
        this.loading = false;
        this.$refs.modal.close();
        this.$emit('refresh');
      });
    },
  },
};
</script>
